// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".disputes-pagination{--bottomMargin:20px;margin:calc(8px*4) auto var(--bottomMargin)}", "",{"version":3,"sources":["webpack://app/containers/disputes/pagination/style.css"],"names":[],"mappings":"AAEA,qBACE,mBAAoB,CAEpB,2CACF","sourcesContent":["@import '@xsolla/uikit/lib/variables.css';\n\n.disputes-pagination {\n  --bottomMargin: 20px;\n\n  margin: var(--ls--lg) auto var(--bottomMargin);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
